/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'success': {
    width: 128,
    height: 128,
    viewBox: '0 0 1025 1024',
    data: '<path pid="0" d="M903.307 121.815l-541.469 541.46-241.882-241.882L0 540.531l361.838 361.845 661.54-660.488z" _fill="#636363"/>'
  }
})
